"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DateRangeFooter = function DateRangeFooter(_ref) {
  var onRangeSelect = _ref.onRangeSelect,
      rangeTemplates = _ref.rangeTemplates;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex border-b border-gray-200"
  }, rangeTemplates.map(function (template) {
    var _template$range = template.range,
        range = _template$range === void 0 ? [] : _template$range,
        label = template.label;
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: "p-2 cursor-pointer hover:bg-primary hover:text-white",
      key: label,
      onClick: function onClick() {
        return onRangeSelect(range);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: label
    }));
  }));
};

DateRangeFooter.propTypes = {
  onRangeSelect: _propTypes["default"].func,
  rangeTemplates: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
DateRangeFooter.defaultProps = {
  onRangeSelect: function onRangeSelect() {},
  rangeTemplates: []
};
var _default = DateRangeFooter;
exports["default"] = _default;